module.exports = __webpack_public_path__ + "img/kr-product-card3-item4-step2.ba76ac7.png";